import React from 'react'
import SecondaryMenuItem from './SecondaryMenuItem'
import { makeStyles, Typography, Grid } from '@material-ui/core'
import { ChevronLeft } from '@material-ui/icons'
import NewIcon from 'components/commons/NewIcon'

const useStyles = makeStyles(theme => ({
   secondaryMenuTitleContainer: {
      padding: theme.spacing(2),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(1)
   },
   itemFlex: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
   },

   secondaryMenuTitle: {
      paddingLeft: '4px',
      font: 'normal normal bold 18px/24px Roboto',
      letterSpacing: '0px',
      color: '#43496A'
   },
   secondaryMenuTitleIcon: {
      cursor: 'pointer'
   }
}))

const SecondaryMenu = ({
   secondarySubmenu,
   setSecondaryDrawerOpen,
   buildCollapsableMenu,
   open,
   setOpen
}) => {
   const classes = useStyles()

   return (
      <Grid>
         <Grid className={classes.secondaryMenuTitleContainer}>
            <Typography className={classes.secondaryMenuTitle}>
               {secondarySubmenu?.title}
            </Typography>
            <div className={classes.itemFlex}>
               {secondarySubmenu?.newOption ? <NewIcon /> : null}
               <ChevronLeft
                  className={classes.secondaryMenuTitleIcon}
                  onClick={() => setSecondaryDrawerOpen(false)}
               />
            </div>
         </Grid>
         {secondarySubmenu?.menus?.map((submenu, idx) => (
            <SecondaryMenuItem
               key={idx}
               submenu={submenu}
               open={open}
               setOpen={setOpen}
               buildCollapsableMenu={buildCollapsableMenu}
            />
         ))}
      </Grid>
   )
}

export default SecondaryMenu
